import React, { createContext, useState, useContext, useEffect } from 'react';
import authService from '../service/authService.js';

const AuthContext = createContext(); //se crea el contenedor vacio que gfuarda los datos de autenticacion

export const AuthProvider = ({ children }) => {
    
    const [usuario, setUsuario] = useState(null);   //usuario logueado o no
    const [cargando, setCargando] = useState(true); //sesion activa o no
    const [error, setError] = useState(null); //registro de errores de autenticacion

    //se ejecuta una sola vez
    useEffect(() => {
        const usuarioActual = authService.getUsuarioActual();  //busca si hay un usuario guardado (ahora en cookie)
        if (usuarioActual) {
            setUsuario(usuarioActual); //si hay usuario lo cargo
        }
        setCargando(false); //ya se sabe que hay una sesion activa
    }, []);


    const login = async (email, password) => {
        setError(null);
        try {
            const resultado = await authService.login(email, password); //envia al back el email y la constraseña
            setUsuario(resultado.usuario); //setea al usuario como activo
            return resultado; //	Devuelve el token y usuario al componente que llamo a login
        } catch (error) {
            setError(error.message);
            throw error;
        }
    };

    
    const logout = () => {
        authService.logout(); // elimina la cookie y el usuario guardado
        setUsuario(null);
    };

    
    const registrar = async (datos) => {
        setError(null); //limpia errores anteriores
        try {
            const resultado = await authService.registrar(datos);  //hace el post del register
            return resultado; 
        } catch (error) {
            setError(error.message);
            throw error;
        }
    };

    
    const tieneRol = (rolesPermitidos) => {
        if (!usuario) return false;
        return rolesPermitidos.includes(usuario.rol); //se fija que el usuario tenga un rol permitido
    };

    const value = {
        usuario,
        cargando,
        error,
        login,
        logout,
        registrar,
        tieneRol,
        isAuthenticated: !!usuario
    }; //esto lo puede usar cualquier componente que use el useAuth()

    return ( //es el componente que provee los datos (del value)
        <AuthContext.Provider value={value}> 
            {children}
        </AuthContext.Provider>
    );
};

//el children es el contenido de la app

//Hook para acceder a los datos desde cualquier componente
//ver uso en privateRoute
export const useAuth = () => {
    const context = useContext(AuthContext); //obtiene el valor del contexto entero, el que se creo arriba. Tiene los valores
    if (!context) {
        throw new Error('useAuth debe usarse dentro de AuthProvider');
    }
    return context;
};